import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Edit = ({
  size,
  type,
  theme,
  className,
  dataTestId = "edit-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.86 1.53a.67.67 0 0 1 .94 0l2.67 2.67c.26.26.26.68 0 .94l-9.33 9.33c-.13.13-.3.2-.47.2H2a.67.67 0 0 1-.67-.67v-2.67c0-.17.07-.34.2-.47l9.33-9.33ZM10.28 4 12 5.72l1.06-1.05-1.73-1.73L10.28 4Zm.78 2.67L9.33 4.94l-5.72 5.73 1.72 1.72 5.73-5.72Zm-6.67 6.66-1.72-1.72v1.72h1.72Z"
    />
  </SVGIcon>
);
